export const createQueryStringFromIds = (selectedPhotos: number[], albumId?: string | undefined) => {
  let idsParams = selectedPhotos
    .map((id) => `ids=${encodeURIComponent(id)}`) // Encode each ID
    .join('&'); // Join with &

  if (albumId) {
    idsParams += `&albumId=${albumId}`;
  }

  return idsParams;
};
